import { render } from "./GroupVideoPage.vue.js?vue&type=template&id=4c0cd797&scoped=true!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./GroupVideoPage.vue?vue&type=template&id=4c0cd797&scoped=true"
import script from "./GroupVideoPage.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./GroupVideoPage.vue?vue&type=script&lang=js"
export * from "./GroupVideoPage.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./GroupVideoPage.vue?vue&type=script&lang=js"

import "./GroupVideoPage.vue.css?vue&type=style&index=0&id=4c0cd797&scoped=true&lang=css!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./GroupVideoPage.vue?vue&type=style&index=0&id=4c0cd797&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c0cd797"],['__file',"src/Web/scripts/pages/community/GroupVideoPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4c0cd797"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4c0cd797', __exports__)) {
    api.reload('4c0cd797', __exports__)
  }
  
  module.hot.accept("./GroupVideoPage.vue.js?vue&type=template&id=4c0cd797&scoped=true!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./GroupVideoPage.vue?vue&type=template&id=4c0cd797&scoped=true", () => {
    api.rerender('4c0cd797', render)
  })

}


export default __exports__